export enum AccountType {
    Standard = 0,
    Trial = 1
}
